import { render } from "./App.vue?vue&type=template&id=5fcb07d2"
const script = {}

import exportComponent from "/var/www/FriendlyFac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__